"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuctionOrNakedProperty = exports.checkSrpUrlHasTwinOnSeoUrl = exports.getSortValuePart = exports.BUILDING_CONTITIONS_LABEL = exports.FEATURES_LABEL = exports.analyzeLocalities = exports.locationObject = exports.getAliasLocalities = exports.getLocalities = exports.checkIfRentLocationsQualifyForNewTitle = exports.rentLocationsQualifyForNewTitle = exports.getTotalListings = exports.getAgentForDesc = exports.getCategoryDefault = exports.getRange = exports.getFeaturesDesc = exports.getAgentCategory = exports.agentObject = exports.getRoomRange = exports.getRoomsRange = exports.TR_ENCODED = exports.getPropertyTypes = exports.integerWithEuropeThousandSeparator = exports.capitalize = exports.HELMET_PDP = exports.HELMET_SRP_NO_PROP_NO_LOC_TYPE = exports.HELMET_SRP_NO_PROP_TYPE = exports.HELMET_SRP_NO_LOC_TYPE = exports.HELMET_SRP_TYPE = exports.HELMET_AGENCY_SRP_TYPE = exports.HELMET_AGENCY_NOT_FOUND_TYPE = exports.HELMET_AGENCY_TYPE = void 0;

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

var _SeoManager = _interopRequireDefault(require("../SeoManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _readOnlyError(name) { throw new Error("\"" + name + "\" is read-only"); }

var HELMET_AGENCY_TYPE = 'HELMET_AGENCY_TYPE';
exports.HELMET_AGENCY_TYPE = HELMET_AGENCY_TYPE;
var HELMET_AGENCY_NOT_FOUND_TYPE = 'HELMET_AGENCY_NOT_FOUND_TYPE';
exports.HELMET_AGENCY_NOT_FOUND_TYPE = HELMET_AGENCY_NOT_FOUND_TYPE;
var HELMET_AGENCY_SRP_TYPE = 'HELMET_AGENCY_SRP_TYPE';
exports.HELMET_AGENCY_SRP_TYPE = HELMET_AGENCY_SRP_TYPE;
var HELMET_SRP_TYPE = 'HELMET_SRP_TYPE';
exports.HELMET_SRP_TYPE = HELMET_SRP_TYPE;
var HELMET_SRP_NO_LOC_TYPE = 'HELMET_SRP_NO_LOC_TYPE';
exports.HELMET_SRP_NO_LOC_TYPE = HELMET_SRP_NO_LOC_TYPE;
var HELMET_SRP_NO_PROP_TYPE = 'HELMET_SRP_NO_PROP_TYPE';
exports.HELMET_SRP_NO_PROP_TYPE = HELMET_SRP_NO_PROP_TYPE;
var HELMET_SRP_NO_PROP_NO_LOC_TYPE = 'HELMET_SRP_NO_PROP_NO_LOC_TYPE';
exports.HELMET_SRP_NO_PROP_NO_LOC_TYPE = HELMET_SRP_NO_PROP_NO_LOC_TYPE;
var HELMET_PDP = 'HELMET_PDP';
exports.HELMET_PDP = HELMET_PDP;

var capitalize = function capitalize(input) {
  if (!input) return '';
  return "".concat(input.charAt(0).toUpperCase()).concat(input.slice(1));
};

exports.capitalize = capitalize;

var integerWithEuropeThousandSeparator = function integerWithEuropeThousandSeparator(num) {
  return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : '';
};

exports.integerWithEuropeThousandSeparator = integerWithEuropeThousandSeparator;

var getPropertyTypes = function getPropertyTypes(propertyTypes) {
  var license_type_groups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = license_type_groups.length ? license_type_groups : propertyTypes;
  var pluralExcepions = license_type_groups.length ? {} : _SeoManagerHelpers.PROPERTY_TYPES_PLURAL_EXCEPTIONS;
  var plurals = license_type_groups.length ? _SeoManagerHelpers.LICENSE_TYPE_GROUPS_PLURAL : _SeoManagerHelpers.PROPERTY_TYPES_PLURAL;

  if (!Array.isArray(list)) {
    list = (_readOnlyError("list"), [list]);
  }

  return list.map(function (x) {
    return pluralExcepions[x.slug] || plurals[x.slug];
  }).join(', ') || 'annunci';
};

exports.getPropertyTypes = getPropertyTypes;
var TR_ENCODED = {
  it: {
    buy: 'vendita',
    rent: 'affitto',
    vendita: 'vendita',
    affitti: 'affitto',
    affitto: 'affitto',
    any: 'vendita e affitto',
    all: 'vendita e affitto'
  }
};
exports.TR_ENCODED = TR_ENCODED;

var getRoomsRange = function getRoomsRange(roomsRange) {
  var withPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var default_rooms = "".concat(withPrefix ? 'i' : '', "case");

  try {
    switch (parseInt(roomsRange, 10)) {
      case 1:
        return "".concat(withPrefix ? 'i ' : '', "monolocali");

      case 2:
        return "".concat(withPrefix ? 'i ' : '', "bilocali");

      case 3:
        return "".concat(withPrefix ? 'i ' : '', "trilocali");

      case 4:
        return "".concat(withPrefix ? 'i ' : '', "quadrilocali");

      default:
        return default_rooms;
    }
  } catch (error) {
    return default_rooms;
  }
};

exports.getRoomsRange = getRoomsRange;

var getRoomRange = function getRoomRange(roomRange) {
  var withPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var default_room = "".concat(withPrefix ? 'e' : '', "appartamento");

  try {
    switch (parseInt(roomRange, 10)) {
      case 1:
        return "".concat(withPrefix ? 'i ' : '', "monolocale");

      case 2:
        return "".concat(withPrefix ? 'i ' : '', "bilocale");

      case 3:
        return "".concat(withPrefix ? 'i ' : '', "trilocale");

      case 4:
        return "".concat(withPrefix ? 'i ' : '', "quadrilocale");

      default:
        return default_room;
    }
  } catch (error) {
    return default_room;
  }
};

exports.getRoomRange = getRoomRange;

var agentObject = function agentObject(agentCategory) {
  switch (agentCategory) {
    case 'agency':
      return 'agenzie';

    case 'private':
      return 'privati';

    default:
      return 'costruttori';
  }
};

exports.agentObject = agentObject;

var getAgentCategory = function getAgentCategory(agentCategory) {
  var title;

  if (!Array.isArray(agentCategory)) {
    title = " da ".concat(agentCategory);
  } else if (agentCategory.length > 1) {
    var agents = '';

    for (var i = 0; i < agentCategory.length; i += 1) {
      agents += i === 0 ? agentObject(agentCategory[i]) : ", ".concat(agentObject(agentCategory[i]));
    }

    title = " da ".concat(agents);
  } else {
    switch (agentCategory[0]) {
      case 'agency':
        title = " da ".concat(agentObject(agentCategory[0]));
        break;

      case 'private':
        title = " da ".concat(agentObject(agentCategory[0]));
        break;

      default:
        // costruttori
        title = " da ".concat(agentObject(agentCategory[0]));
    }
  }

  return title;
};

exports.getAgentCategory = getAgentCategory;

var getFeaturesDesc = function getFeaturesDesc(features, ncommas, fd, pos) {
  var usableFeatures = _toConsumableArray(features);

  if (usableFeatures.length === 1 && usableFeatures[0] === 'nuda-proprieta') {
    usableFeatures = [];
  }

  var isPublisherType = usableFeatures.filter(function (ft) {
    return _SeoManagerHelpers.PUBLISHER_LABELS.includes(ft);
  }).length > 0;
  var featureDesc = usableFeatures.length === 0 || ncommas === 0 ? '' : " ".concat(isPublisherType && usableFeatures.length === 1 ? ' ' : 'con ').concat(ncommas > 1 ? "".concat(fd.substring(0, pos), " ").concat(isPublisherType ? ' ' : ' e').concat(fd.substring(pos + 1)) : fd, " ");
  return featureDesc !== ' con  ' ? featureDesc.replace('con senza', 'senza') : '';
};

exports.getFeaturesDesc = getFeaturesDesc;

var getRange = function getRange(rangePrice) {
  var range;
  var rmin = rangePrice.minimum;
  var rmax = rangePrice.maximum;

  if (rangePrice.minimum !== 'any' && rangePrice.maximum !== 'any') {
    range = " con prezzo compreso tra ".concat(integerWithEuropeThousandSeparator(rmin), "\u20AC e ").concat(integerWithEuropeThousandSeparator(rmax), "\u20AC");
  } else if (rangePrice.minimum !== 'any') {
    range = " con prezzo maggiore di ".concat(integerWithEuropeThousandSeparator(rmin), "\u20AC");
  } else if (rangePrice.maximum !== 'any') {
    range = " con prezzo minore di ".concat(integerWithEuropeThousandSeparator(rmax), "\u20AC");
  } else {
    range = '';
  }

  return range;
};

exports.getRange = getRange;

var getCategoryDefault = function getCategoryDefault(category) {
  var defaultType;

  switch (category) {
    case 'vacanze':
    case 'case-vacanza':
      defaultType = 'Case vacanza';
      break;

    case 'commerciale':
      defaultType = 'Immobili e Attività commerciali';
      break;

    case 'cantine-solai':
      defaultType = 'Cantine, solai';
      break;

    case 'garage-posti-auto':
      defaultType = 'Garage, posti auto';
      break;

    case 'stanze':
      defaultType = 'Stanze';
      break;

    case 'terreni':
      defaultType = 'Terreni';
      break;

    case 'uffici':
      defaultType = 'Uffici';
      break;

    case 'capannoni':
      defaultType = 'Capannoni';
      break;

    case 'edifici-palazzi':
      defaultType = 'Edifici, stabili e palazzi';
      break;

    default:
      defaultType = 'Case';
  }

  return defaultType;
};

exports.getCategoryDefault = getCategoryDefault;

var getAgentForDesc = function getAgentForDesc(agentCategory) {
  var agent;

  if (!Array.isArray(agentCategory)) {
    agent = " da ".concat(agentCategory);
  } else if (agentCategory.length > 1) {
    var agents = '';

    for (var i = 0; i < agentCategory.length; i += 1) {
      if (i === 0) {
        agents += agentObject(agentCategory[i]);
      } else if (i === agentCategory.length - 1) {
        agents += " e ".concat(agentObject(agentCategory[i]));
      } else {
        agents += ", ".concat(agentObject(agentCategory[i]));
      }
    }

    agent = " da ".concat(agents, " ");
  } else {
    agent = " da ".concat(agentObject(agentCategory[0]), " ");
  }

  return agent;
};

exports.getAgentForDesc = getAgentForDesc;

var getTotalListings = function getTotalListings(count) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' gli ';

  // return `${getTotalListings(count)}`;
  // return `${count === 0 ? 'Annunci' : `${count}`}`.trim();
  if (count && !isNaN(count)) {
    count = integerWithEuropeThousandSeparator(count);
  }

  return count;
};

exports.getTotalListings = getTotalListings;

var extractZonesForRobots = function extractZonesForRobots(_ref) {
  var zones = _ref.zones,
      blocks = _ref.blocks,
      position = _ref.position,
      withZone = _ref.withZone;
  var mergedZonesBlocks = [].concat(_toConsumableArray(zones), _toConsumableArray(blocks)); // TECH-6588: mix di zone e quartieri

  var zonestitle = '';
  var parents = [];
  var parentsObj = {}; // start -> TECH-6588: mix di zone e quartieri

  for (var i = 0; i < mergedZonesBlocks.length; i += 1) {
    parents.push(mergedZonesBlocks[i].levels.L9);
  }

  for (var n = 0; n < parents.length; n += 1) {
    var siblings = [];

    for (var _i = 0; _i < mergedZonesBlocks.length; _i += 1) {
      if (mergedZonesBlocks[_i].levels.L9 === parents[n]) {
        siblings.push(mergedZonesBlocks[_i]);
      }
    }

    parentsObj[parents[n]] = siblings;
  } // end -> TECH-6588: mix di zone e quartieri


  if (Object.keys(parentsObj).length > 0) {
    for (var _i2 = 0; _i2 < Object.keys(parentsObj).length; _i2 += 1) {
      var cityTitle = '';

      var city = Object.keys(parentsObj)[_i2];

      if (parentsObj[Object.keys(parentsObj)[_i2]].length === 1) {
        var zSingleSep = _i2 === Object.keys(parentsObj).length - 1 ? ' e ' : ', ';

        if (_i2 === 0) {
          zSingleSep = '';
        }

        var hasZone = parentsObj[Object.keys(parentsObj)[_i2]][0].levels.L10.toLowerCase().indexOf('zona') > -1;
        zonestitle += withZone ? "".concat(zSingleSep, "a ").concat(city, " ").concat(hasZone ? 'in ' : 'in zona', " ").concat(parentsObj[Object.keys(parentsObj)[_i2]][0].levels.L10) : "".concat(zSingleSep, "a ").concat(city);
      } else {
        for (var _n = 0; _n < parentsObj[Object.keys(parentsObj)[_i2]].length; _n += 1) {
          var area = parentsObj[Object.keys(parentsObj)[_i2]][_n];

          var areaLvl = area.level; // TECH-6588: mix di zone e quartieri

          var zSep = _i2 === parentsObj[Object.keys(parentsObj)[_i2]].length - 1 ? ' e' : ','; // TECH-6588: mix di zone e quartieri
          // cityTitle += n === 0 ? `${area.levels.L10.replace(/\//g, ',')}` : `${zSep} ${area.levels.L10}`;

          cityTitle += _n === 0 ? "".concat(area.levels["L".concat(areaLvl)].replace(/\//g, ',')) : "".concat(zSep, " ").concat(area.levels["L".concat(areaLvl)]);
        }

        var zMultiSep = _i2 === Object.keys(parentsObj).length - 1 ? ' e ' : ', ';

        if (_i2 === 0) {
          zMultiSep = '';
        }

        if (position === 'title') {
          zonestitle += withZone ? "".concat(zMultiSep, "a ").concat(city, " nelle zone: ").concat(cityTitle) : "".concat(zMultiSep, "a ").concat(city);
        } else {
          zonestitle += withZone ? "".concat(zMultiSep, "a ").concat(city, " nelle zone ").concat(cityTitle) : "".concat(zMultiSep, "a ").concat(city);
        }
      }
    }
  }

  return zonestitle;
};

var extractBlocksForRobots = function extractBlocksForRobots(_ref2) {
  var blocks = _ref2.blocks,
      position = _ref2.position,
      withBlock = _ref2.withBlock;
  var blockstitle = '';
  var parents = [];
  var parentsObj = {};

  for (var i = 0; i < blocks.length; i += 1) {
    parents.push(blocks[i].levels.L9);
  }

  for (var n = 0; n < parents.length; n += 1) {
    var siblings = [];

    for (var _i3 = 0; _i3 < blocks.length; _i3 += 1) {
      if (blocks[_i3].levels.L9 === parents[n]) {
        siblings.push(blocks[_i3]);
      }
    }

    parentsObj[parents[n]] = siblings;
  }

  if (Object.keys(parentsObj).length > 0) {
    for (var _i4 = 0; _i4 < Object.keys(parentsObj).length; _i4 += 1) {
      var cityTitle = '';

      var city = Object.keys(parentsObj)[_i4];

      if (parentsObj[Object.keys(parentsObj)[_i4]].length === 1) {
        var zSingleSep = _i4 === Object.keys(parentsObj).length - 1 ? ' e ' : ', ';

        if (_i4 === 0) {
          zSingleSep = '';
        }

        blockstitle += withBlock ? "".concat(zSingleSep, "nel quartiere ").concat(parentsObj[Object.keys(parentsObj)[_i4]][0].levels.L11, " di ").concat(city) : "".concat(zSingleSep, "nel quartiere ").concat(parentsObj[Object.keys(parentsObj)[_i4]][0].levels.L11);
      } else {
        for (var _n2 = 0; _n2 < parentsObj[Object.keys(parentsObj)[_i4]].length; _n2 += 1) {
          var area = parentsObj[Object.keys(parentsObj)[_i4]][_n2];

          var zSep = _i4 === parentsObj[Object.keys(parentsObj)[_i4]].length - 1 ? ' e' : ',';
          cityTitle += _n2 === 0 ? "".concat(area.levels.L11.replace(/\//g, ',')) : "".concat(zSep, " ").concat(area.levels.L11);
        }

        var zMultiSep = _i4 === Object.keys(parentsObj).length - 1 ? ' e ' : ', ';

        if (_i4 === 0) {
          zMultiSep = '';
        }

        if (position === 'title') {
          blockstitle += withBlock ? "".concat(zMultiSep, "nei quartieri ").concat(cityTitle, " di ").concat(city) : "".concat(zMultiSep, "nei quartieri ").concat(cityTitle);
        } else {
          blockstitle += withBlock ? "".concat(zMultiSep, "nei quartieri ").concat(cityTitle, " di ").concat(city) : "".concat(zMultiSep, "nei quartieri ").concat(cityTitle);
        }
      }
    }
  }

  return blockstitle;
};

var extractMetroStopsForRobots = function extractMetroStopsForRobots(_ref3) {
  var _ref3$stops = _ref3.stops,
      stops = _ref3$stops === void 0 ? [] : _ref3$stops,
      _ref3$position = _ref3.position,
      position = _ref3$position === void 0 ? 'title' : _ref3$position;

  if (!stops.length) {
    return '';
  }

  var multiple = stops.length > 1;
  return " vicino all".concat(multiple ? 'e' : 'a', " fermat").concat(multiple ? "e".concat(position === 'title' ? ':' : '', " ") : 'a metro ').concat(stops.map(function (stop) {
    return stop.name;
  }).join(', '));
};

var extractMetroLinesForRobots = function extractMetroLinesForRobots(_ref4) {
  var _ref4$line = _ref4.line,
      line = _ref4$line === void 0 ? [] : _ref4$line;

  if (!line.length) {
    return '';
  }

  return " vicino alle fermate della ".concat(line[0].name);
};

var extractNonAdminZoneForRobots = function extractNonAdminZoneForRobots(_ref5) {
  var _ref5$zones = _ref5.zones,
      zones = _ref5$zones === void 0 ? [] : _ref5$zones,
      _ref5$position = _ref5.position,
      position = _ref5$position === void 0 ? 'title' : _ref5$position;

  if (!zones.length) {
    return '';
  }

  return " a ".concat(zones.map(function (zone) {
    return zone.name;
  }).join(', '));
};

var extractNonAdminSubZoneForRobots = function extractNonAdminSubZoneForRobots(_ref6) {
  var _ref6$subzones = _ref6.subzones,
      subzones = _ref6$subzones === void 0 ? [] : _ref6$subzones,
      _ref6$position = _ref6.position,
      position = _ref6$position === void 0 ? 'title' : _ref6$position;

  if (!subzones.length) {
    return '';
  }

  return " in ".concat(subzones.map(function (zone) {
    return zone.name;
  }).join(', '));
};

var rentLocationsQualifyForNewTitle = function rentLocationsQualifyForNewTitle() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$locations = _ref7.locations,
      locations = _ref7$locations === void 0 ? [] : _ref7$locations;

  var citiesThatDoNotQulify = ['napoli', 'palermo', 'genova', 'bari', 'catania', 'messina', 'prato', 'taranto', 'reggio-calabria', 'cagliari', 'foggia', 'salerno', 'latina', 'sassari', 'pescara', 'siracusa', 'barletta', 'lecce'];
  var qualify = true;
  locations.map(function (curr) {
    if (curr.level !== 9 || citiesThatDoNotQulify.includes(curr.slug)) {
      qualify = false;
    }
  });
  return qualify;
};

exports.rentLocationsQualifyForNewTitle = rentLocationsQualifyForNewTitle;

var checkIfRentLocationsQualifyForNewTitle = function checkIfRentLocationsQualifyForNewTitle(_ref8) {
  var locations = _ref8.locations,
      channel = _ref8.channel,
      bcNew = _ref8.bcNew,
      publisherType = _ref8.publisherType,
      roomsCondition = _ref8.roomsCondition,
      featuresDesc = _ref8.featuresDesc,
      nearSubway = _ref8.nearSubway,
      surrounding = _ref8.surrounding,
      pageDescr = _ref8.pageDescr,
      priceRange = _ref8.priceRange;
  return rentLocationsQualifyForNewTitle({
    locations: locations
  }) && channel === 'affitto' && !bcNew && !publisherType && !roomsCondition && !featuresDesc && !nearSubway && !surrounding && !pageDescr && !priceRange;
};

exports.checkIfRentLocationsQualifyForNewTitle = checkIfRentLocationsQualifyForNewTitle;

var getLocalities = function getLocalities(locations, domain, position, withZone) {
  var zonestitle = '';
  var blockstitle = '';
  var otherstitle = '';
  var linetitle = '';
  var stopstitle = '';
  var nonadminzonetitle = '';
  var zones = locations.filter(function (el) {
    return el.type === 'zone';
  });
  var blocks = locations.filter(function (el) {
    return el.type === 'block';
  });
  var metroline = locations.filter(function (el) {
    return el.type === 'metroline';
  });
  var metrostops = locations.filter(function (el) {
    return el.type === 'metrostop';
  });
  var nonadminzones = locations.filter(function (el) {
    return el.type === 'nonadminzone';
  });
  var nonadminsubzones = locations.filter(function (el) {
    return el.type === 'nonadminsubzone';
  });
  var others = locations.filter(function (el) {
    return el.type !== 'zone' && el.type !== 'block' && el.type !== 'metrostop' && el.type !== 'metroline' && el.type !== 'nonadminzone' && el.type !== 'nonadminsubzone';
  });

  if (zones.length > 0) {
    zonestitle = extractZonesForRobots({
      zones: zones,
      blocks: blocks.length > 0 ? blocks : [],
      // TECH-6588: mix di zone e quartieri
      position: position,
      withZone: withZone
    });
  } else if (blocks.length > 0) {
    blockstitle = extractBlocksForRobots({
      blocks: blocks,
      position: position,
      withBlock: withZone
    });
  } else if (metroline.length) {
    linetitle = extractMetroLinesForRobots({
      line: metroline
    });
    otherstitle = "a ".concat(metroline[0].parent.town.name);
  } else if (metrostops.length) {
    stopstitle = extractMetroStopsForRobots({
      stops: metrostops,
      position: position
    });
    otherstitle = "a ".concat(metrostops[0].parent.town.name);
  } else if (nonadminzones.length) {
    nonadminzonetitle = extractNonAdminZoneForRobots({
      zones: nonadminzones,
      position: position
    });
  } else if (nonadminsubzones.length) {
    var _nonadminsubzones$0$p = nonadminsubzones[0].parent;
    _nonadminsubzones$0$p = _nonadminsubzones$0$p === void 0 ? {} : _nonadminsubzones$0$p;
    var _nonadminsubzones$0$p2 = _nonadminsubzones$0$p.nonadminzone,
        nonadminzone = _nonadminsubzones$0$p2 === void 0 ? [] : _nonadminsubzones$0$p2;
    nonadminzonetitle = extractNonAdminZoneForRobots({
      zones: [nonadminzone],
      position: position
    });
    otherstitle = extractNonAdminSubZoneForRobots({
      subzones: nonadminsubzones,
      position: position
    });
  }

  if (others.length > 0) {
    /**
     * TECH-7943
     * aggiunge l'alias ai comuni quando la ricerca è solo su comune (no zone no multilocalità)
     */
    if (locations.length === 1 && others.length === 1 && position === 'title') {
      var _locations = _slicedToArray(locations, 1),
          unique = _locations[0];

      var locObject = locationObject(unique, domain);
      otherstitle = "".concat(locObject.preposition, " ").concat(locObject.location).concat(locObject.alias ? " / ".concat(locObject.alias) : '');
    } else {
      for (var i = 0; i < others.length; i += 1) {
        var _locObject = locationObject(others[i], domain);

        var oSep = i === others.length - 1 ? ' e' : ',';
        otherstitle += i === 0 && zonestitle === '' ? "".concat(_locObject.preposition, " ").concat(_locObject.location) : "".concat(oSep, " ").concat(_locObject.preposition, " ").concat(_locObject.location);
      }
    }
  }

  return " ".concat(zonestitle).concat(blockstitle).concat(nonadminzonetitle).concat(otherstitle).concat(linetitle).concat(stopstitle);
};

exports.getLocalities = getLocalities;

var getAliasLocalities = function getAliasLocalities(_ref9) {
  var _ref9$alias = _ref9.alias,
      alias = _ref9$alias === void 0 ? '' : _ref9$alias;
  return alias === '' ? alias : ", ".concat(alias);
};

exports.getAliasLocalities = getAliasLocalities;

var locationObject = function locationObject(location, domain) {
  if (!location.levels) {
    location.levels = location.slugs || {};
  }

  ;

  switch (location.type) {
    case 'region':
      return {
        preposition: 'in',
        location: location.levels.L4
      };

    case 'street':
      return {
        preposition: 'in',
        location: "".concat(location.levels.L10, ", ").concat(location.levels.L9)
      };

    case 'zone':
      return domain === 'attico' ? {
        preposition: 'a',
        location: location.levels.L9
      } : {
        preposition: 'in',
        location: "".concat(location.levels.L10.replace(/\//g, ','), " (").concat(location.levels.L9, ")")
      };

    case 'block':
      return {
        preposition: ':',
        location: "".concat(location.levels.L11.replace(/\//g, ','), " (").concat(location.levels.L9, ")")
      };

    case 'province':
      return {
        preposition: 'in',
        location: "provincia di ".concat(location.levels.L6)
      };

    case 'region':
      return {
        preposition: 'in',
        location: location.levels.L4
      };

    case 'postalcode':
      return {
        preposition: 'al',
        location: location.postalcode
      };

    case 'freetext':
      return {
        preposition: 'a',
        location: location.name
      };

    default:
      return {
        preposition: 'a',
        location: location.levels.L9,
        alias: location.alias
      };
  }
};

exports.locationObject = locationObject;

var analyzeLocalities = function analyzeLocalities(locations) {
  var flag = false;
  var cities = locations.filter(function (el) {
    return el.type === 'town';
  });
  var zones = locations.filter(function (el) {
    return el.type === 'zone';
  });

  if (cities.length > 0 || zones.length === 1) {
    flag = true;
  }

  return flag;
};

exports.analyzeLocalities = analyzeLocalities;
var FEATURES_LABEL = {
  'box-posto-auto': 'box/posto auto',
  ascensore: 'ascensore',
  'senza-ascensore': 'senza ascensore',
  riscaldamento: 'riscaldamento',
  'riscaldamento-autonomo': 'riscaldamento autonomo',
  'riscaldamento-centralizzato': 'riscaldamento centralizzato',
  giardino: 'giardino',
  'giardino-privato': 'giardino privato',
  'giardino-comune': 'giardino comune',
  balcone: 'balcone',
  terrazzo: 'terrazzo',
  foto: 'foto',
  piscina: 'piscina'
};
exports.FEATURES_LABEL = FEATURES_LABEL;
var BUILDING_CONTITIONS_LABEL = {
  'nuovo': 'in Nuove Costruzioni',
  'da-ristrutturare': 'da Ristrutturare'
}; // calcoliamo la dicitura relativa al sort al maschile e al femminile

exports.BUILDING_CONTITIONS_LABEL = BUILDING_CONTITIONS_LABEL;

var compSortValue = function compSortValue(value) {
  switch (value) {
    case 'price_desc':
      return {
        m: ' costosi',
        f: ' costose'
      };

    case 'price_asc':
      return {
        m: ' economici',
        f: ' economiche'
      };

    case 'surface_desc':
      return {
        m: ' grandi',
        f: ' grandi'
      };

    case 'surface_asc':
      return {
        m: ' piccoli',
        f: ' piccole'
      };

    default:
      return {
        m: '',
        f: ''
      };
  }
}; // calcoliamo la dicitura relativa al sort


var getSortValuePart = function getSortValuePart(category, pTypes, isRooms, value) {
  var forceMasc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (category === 'case' && value) {
    var textObj = compSortValue(value);

    if (pTypes.length === 1) {
      return textObj[_SeoManagerHelpers.PROPERTY_TYPES_GENDER[pTypes[0].slug]];
    }

    if (isRooms) {
      return textObj.m;
    }

    return forceMasc ? textObj.m : textObj[_SeoManagerHelpers.PROPERTY_TYPES_GENDER[category]];
  }

  return '';
};

exports.getSortValuePart = getSortValuePart;

var checkSrpUrlHasTwinOnSeoUrl = function checkSrpUrlHasTwinOnSeoUrl(_ref10) {
  var data = _ref10.data,
      _ref10$domain = _ref10.domain,
      domain = _ref10$domain === void 0 ? 'casa.it' : _ref10$domain,
      _ref10$locale = _ref10.locale,
      locale = _ref10$locale === void 0 ? 'it' : _ref10$locale,
      seoParams = _ref10.seoParams;
  var seoManager = new _SeoManager["default"](domain, locale);
  var uri = seoManager.encode(seoParams);
  var isOk = true;
  /**
   * publisher page srp with pid has twin url only
   * if there arent other params in query string
   * except for those in the list below
   * so /srp/?pId=1 has twin url
   * but /srp/?pId=1&foo=bar has not
   */

  if (seoParams.pId) {
    Object.keys(seoParams).forEach(function (key) {
      if (['pId', 'locations', 'version', 'page', 'channel', 'tr', 'isAgencySrp', 'publisherSlug', 'publisherId', 'propertyTypeGroup', 'isPublisherHp'].indexOf(key) === -1) {
        isOk = false;
      }
    });
  }

  if (!_SeoManager["default"].isSrpUrl(uri) && isOk) {
    return true;
  }

  return false;
};

exports.checkSrpUrlHasTwinOnSeoUrl = checkSrpUrlHasTwinOnSeoUrl;

var getAuctionOrNakedProperty = function getAuctionOrNakedProperty(_ref11) {
  var _ref11$features = _ref11.features,
      features = _ref11$features === void 0 ? [] : _ref11$features,
      _ref11$propertyTypes = _ref11.propertyTypes,
      propertyTypes = _ref11$propertyTypes === void 0 ? '' : _ref11$propertyTypes,
      _ref11$sortValue = _ref11.sortValue,
      sortValue = _ref11$sortValue === void 0 ? '' : _ref11$sortValue,
      _ref11$bcNew = _ref11.bcNew,
      bcNew = _ref11$bcNew === void 0 ? '' : _ref11$bcNew,
      _ref11$isDescription = _ref11.isDescription,
      isDescription = _ref11$isDescription === void 0 ? false : _ref11$isDescription;

  if (features.length && ['asta-immobiliare', 'nuda-proprieta'].includes(features[0])) {
    var isAuction = features[0] === 'asta-immobiliare';
    var hasSortValue = sortValue && sortValue !== ' ';

    if (isDescription) {
      var text = 'annunci di';
      var suffix = isAuction ? ' all\'asta' : ' in nuda proprietà';
      var bc = " ".concat(bcNew);

      if (propertyTypes) {
        text += " ".concat(propertyTypes).concat(hasSortValue ? sortValue : '').concat(bcNew ? bc : '').concat(suffix);
      } else if (isAuction) {
        if (hasSortValue || bcNew) {
          text += " case e appartamenti".concat(sortValue).concat(bc).concat(suffix);
        } else {
          text += ' aste immobiliari';
        }
      } else {
        if (hasSortValue) {
          text += " case e appartamenti".concat(sortValue).concat(bc).concat(suffix);
        } else {
          text += " nude propriet\xE0".concat(bc);
        }
      }

      return {
        isAuction: isAuction,
        text: text
      };
    } else if (propertyTypes) {
      return {
        isAuction: isAuction,
        text: isAuction ? "".concat(propertyTypes).concat(sortValue).concat(bcNew, " in asta") : "".concat(propertyTypes).concat(sortValue).concat(bcNew, " in nuda propriet\xE0")
      };
    } else if (hasSortValue) {
      return {
        isAuction: isAuction,
        text: isAuction ? "Case ".concat(sortValue).concat(bcNew, " in asta") : "Case ".concat(sortValue).concat(bcNew, " in nuda propriet\xE0")
      };
    } else {
      return {
        isAuction: isAuction,
        text: isAuction ? bcNew ? "Case".concat(bcNew, " in asta") : 'Aste immobiliari' : "Nude propriet\xE0".concat(bcNew)
      };
    }
  }

  return null;
};

exports.getAuctionOrNakedProperty = getAuctionOrNakedProperty;